
$(document).ready(function () {
  //网红视频
  $("#shopify-section-template--16207127019660__1648879217c75ad56f .video-container").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Top_Video',
      "section_id": 'shopify-section-template--16359081803916__1648879217c75ad56f',
      "section_name": "网红视频",
    });
  })
  $("#shopify-section-template--16207127019660__1648879217c75ad56f .lightly-spaced-row-above").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Top_Video_Buy',
      "section_id": 'shopify-section-template--16359081803916__1648879217c75ad56f',
      "section_name": "网红视频",
    });
  })
  //金刚区
  $("#shopify-section-template--16207127019660__76c46637-bcef-4b8b-b96e-9304d7282a3b").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'King_Kong1',
      "section_id": 'shopify-section-template--16207127019660__76c46637-bcef-4b8b-b96e-9304d7282a3b',
      "section_name": "金刚区",
    });
  })
  $("#shopify-section-template--16207127019660__2e754655-6e42-4031-b82c-93905821510e .gallery__item").on('click', function (event) {
    const num = $(this).index() + 2
    gtag('event', 'click', {
      "content_type": 'King_Kong' + num,
      "section_id": 'shopify-section-template--16207127019660__2e754655-6e42-4031-b82c-93905821510e',
      "section_name": "金刚区",
    });
  })
  // m端产品集合区
  $("#shopify-section-template--16207127019660__16558987444f0b6445 .product-block").on('click', function (event) {
    const category_name = $(this).data('category-name');
    const index = $(this).index() + 1
    gtag('event', 'click', {
      "content_type": 'Product_Category' + index,
      "section_id": 'shopify-section-template--16207127019660__16558987444f0b6445',
      "section_name": '' + category_name,
    });
  })
  //大显小内衣板块
  $("#shopify-section-template--16207127019660__16359278676808bea5 .product-list").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Minimizer_Bra',
      "section_id": 'shopify-section-template--16207127019660__16359278676808bea5',
      "section_name": "大显小内衣板块",
    });
  })
  $("#shopify-section-template--16207127019660__16359278676808bea5 .small-feature-link").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Minimizer_Bra_More',
      "section_id": 'shopify-section-template--16207127019660__16359278676808bea5',
      "section_name": "大显小内衣板块",
    });
  })

  $("#shopify-section-template--16207127019660__16359278676808bea5 .prev").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'prev',
      "section_id": 'shopify-section-template--16207127019660__16359278676808bea5',
      "section_name": "大显小内衣板块",
    });
  })

  $("#shopify-section-template--16207127019660__16359278676808bea5 .next").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'next',
      "section_id": 'shopify-section-template--16207127019660__16359278676808bea5',
      "section_name": "大显小内衣板块",
    });
  })
  //用户精选评论
  $("#shopify-section-template--16207127019660__df224142-3b3b-4014-91bd-adcb051a4bad .swiper-wrapper").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Top_Review',
      "section_id": 'shopify-section-template--16207127019660__df224142-3b3b-4014-91bd-adcb051a4bad',
      "section_name": "大显小内衣板块",
    });
  })
  $("#shopify-section-template--16207127019660__df224142-3b3b-4014-91bd-adcb051a4bad .view-more-link").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Top_Review_More',
      "section_id": 'shopify-section-template--16207127019660__df224142-3b3b-4014-91bd-adcb051a4bad',
      "section_name": "大显小内衣板块",
    });
  })
  //秋季新品到货板块
  $("#shopify-section-template--16207127019660__16467109739bde389a .product-list").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'New_Arrivals',
      "section_id": 'shopify-section-template--16207127019660__16467109739bde389a',
      "section_name": "秋季新品到货板块",
    });
  })
  $("#shopify-section-template--16207127019660__16467109739bde389a .small-feature-link").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'New_Arrivals_More',
      "section_id": 'shopify-section-template--16207127019660__16467109739bde389a',
      "section_name": "秋季新品到货板块",
    });
  })

  $("#shopify-section-template--16207127019660__16467109739bde389a .prev").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'prev',
      "section_id": 'shopify-section-template--16207127019660__16467109739bde389a',
      "section_name": "秋季新品到货板块",
    });
  })

  $("#shopify-section-template--16207127019660__16467109739bde389a .next").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'next',
      "section_id": 'shopify-section-template--16207127019660__16467109739bde389a',
      "section_name": "秋季新品到货板块",
    });
  })
  //腰带（塑身衣）板块
  $("#shopify-section-template--16207127019660__1641901962dfe70461 .product-list").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Waist_Trainer',
      "section_id": 'shopify-section-template--16207127019660__1641901962dfe70461',
      "section_name": "腰带（塑身衣）板块",
    });
  })
  $("#shopify-section-template--16207127019660__1641901962dfe70461 .small-feature-link").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Waist_Trainer_More',
      "section_id": 'shopify-section-template--16207127019660__1641901962dfe70461',
      "section_name": "腰带（塑身衣）板块",
    });
  })

  $("#shopify-section-template--16207127019660__1641901962dfe70461 .prev").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'prev',
      "section_id": 'shopify-section-template--16207127019660__1641901962dfe70461',
      "section_name": "腰带（塑身衣）板块",
    });
  })

  $("#shopify-section-template--16207127019660__1641901962dfe70461 .next").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'next',
      "section_id": 'shopify-section-template--16207127019660__1641901962dfe70461',
      "section_name": "腰带（塑身衣）板块",
    });
  })
  //矫正胸罩板块
  $("#shopify-section-template--16207127019660__164301749825401292 .product-list").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Support_Bra',
      "section_id": 'shopify-section-template--16207127019660__164301749825401292',
      "section_name": "矫正胸罩板块",
    });
  })
  $("#shopify-section-template--16207127019660__164301749825401292 .small-feature-link").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Support_Bra_More',
      "section_id": 'shopify-section-template--16207127019660__164301749825401292',
      "section_name": "矫正胸罩板块",
    });
  })
  $("#shopify-section-template--16207127019660__164301749825401292 .prev").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'prev',
      "section_id": 'shopify-section-template--16207127019660__164301749825401292',
      "section_name": "矫正胸罩板块",
    });
  })
  $("#shopify-section-template--16207127019660__164301749825401292 .next").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'next',
      "section_id": 'shopify-section-template--16207127019660__164301749825401292',
      "section_name": "矫正胸罩板块",
    });
  })
  //Veimia油管口碑
  $("#shopify-section-template--16207127019660__8d60e35a-9c04-4533-91e0-864160c13090 .image-overlap__image").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Veimia_Youtube_Image',
      "section_id": 'shopify-section-template--16207127019660__8d60e35a-9c04-4533-91e0-864160c13090',
      "section_name": "Veimia油管口碑",
    });
  })
  $("#shopify-section-template--16207127019660__8d60e35a-9c04-4533-91e0-864160c13090 .lightly-spaced-row-above").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Veimia_Youtube_Details',
      "section_id": 'shopify-section-template--16207127019660__8d60e35a-9c04-4533-91e0-864160c13090',
      "section_name": "Veimia油管口碑",
    });
  })
  //Veimia智慧包
  $("#shopify-section-template--16207127019660__1112073b-b59c-4243-9f09-1e2072489b0c .image-overlap__image").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Knowledge_Bag',
      "section_id": 'shopify-section-template--16207127019660__1112073b-b59c-4243-9f09-1e2072489b0c',
      "section_name": "Veimia智慧包",
    });
  })
  $("#shopify-section-template--16207127019660__1112073b-b59c-4243-9f09-1e2072489b0c .lightly-spaced-row-above").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Knowledge_Bag_Details',
      "section_id": 'shopify-section-template--16207127019660__1112073b-b59c-4243-9f09-1e2072489b0c',
      "section_name": "Veimia智慧包",
    });
  })

  //搜索框页面
  $("#main-search .main-search__container .main-search__button").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Search_input',
      "section_id": 'main-search',
      "section_name": "搜索框页面",
      "input_value": $("#main-search .main-search__container .main-search__input").val(),
    });
  })
  $("#main-search .main-search__container  .main-search__close").on('click', function (event) {
    gtag('event', 'click', {
      "content_type": 'Search_colse',
      "section_id": 'main-search',
      "section_name": "搜索框页面",
    });
  })
  $("#main-search .main-search__container .search-suggestions__item-row .search-suggestions__item ").on('click', function (event) {
    const num = $(this).index() + 1
    gtag('event', 'click', {
      "content_type": 'Search_image_' + num,
      "section_id": 'main-search',
      "section_name": "搜索框页面",
    });
  })
  //注册登录页
  $("#login_email").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'login_email',
      "section_id": 'login',
      "section_name": "未登录状态注册登录页面",
    });
  })
  $("#login_password").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'Login_password',
      "section_id": 'login',
      "section_name": "未登录状态注册登录页面",
    });
  })
  $("#customer_login .action_bottom").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'login_btn',
      "section_id": 'login',
      "section_name": "未登录状态注册登录页面",
    });
  })
  $(".go-register").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'register_btn',
      "section_id": 'login',
      "section_name": "未登录状态注册登录页面",
    });
  })
  //登录状态下我的账户页面
  $("#admin_header action_link a").on("click", function (event) {
    if ($(this).index() == 0) {
      gtag('event', 'click', {
        "content_type": 'go_store',
        "section_id": 'admin',
        "section_name": "登录状态下我的账户页面",
      });
    } else {
      gtag('event', 'click', {
        "content_type": 'go_logout',
        "section_id": 'admin',
        "section_name": "登录状态下我的账户页面",
      });
    }
  })
  $(".account-navigation a").on("click", function (event) {
    switch ($(this).index()) {
      case 0:
        gtag('event', 'click', {
          "content_type": 'my_history',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 1:
        gtag('event', 'click', {
          "content_type": 'my_discount',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 2:
        gtag('event', 'click', {
          "content_type": 'my_integral',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 3:
        gtag('event', 'click', {
          "content_type": 'my_order',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 4:
        gtag('event', 'click', {
          "content_type": 'my_Information',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 5:
        gtag('event', 'click', {
          "content_type": 'my_notice',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 6:
        gtag('event', 'click', {
          "content_type": 'my_noticeList',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 7:
        gtag('event', 'click', {
          "content_type": 'my_gift_card',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
      case 8:
        gtag('event', 'click', {
          "content_type": 'my_help',
          "section_id": 'admin',
          "section_name": "未登录状态注册登录页面",
        });
        break;
    }
  })

  $("#my-info #view_address").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'my_address',
      "section_id": 'my-info',
      "section_name": "登录状态下我的账户页面",
    });
  })
  $("#notifications .signup-form__email").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'my_email',
      "section_id": 'notifications',
      "section_name": "登录状态下我的账户页面",
    });
  })
  $("#notifications .signup-form__button").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'subscribe_btn',
      "section_id": 'notifications',
      "section_name": "登录状态下我的账户页面",
    });
  })

  $("#gift-cards .signup-form__button").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'subscribe_btn',
      "section_id": 'notifications',
      "section_name": "登录状态下我的账户页面",
    });
  })


  //商品图
  $(".section-main-product .slick-product-prev").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'prev',
      "section_id": '' + productId,
      "section_name": "商品图",
    });
  })
  $(".section-main-product .slick-product-next").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'next',
      "section_id": '' + productId,
      "section_name": "商品图",
    });
  })
  $(".section-main-product .main-image").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'product_main_image',
      "section_id": '' + productId,
      "section_name": "商品图",
    });
  })
  $(".section-main-product .owl-item").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'product_main_thumbnail',
      "section_id": '' + productId,
      "section_name": "商品图",
    });
  })
  //商品介绍
  // $(".section-main-product .product-form").on("click", '.title-row div', function (event) {
  //   console.log(312313131331);
  //   const productId = $('.section-main-product .product-form').data('product-id');
  //   gtag('event', 'click', {
  //     "content_type": 'product_comment',
  //     "section_id": '' + productId,
  //     "section_name": "商品介绍",
  //   });
  // })
  $(".section-main-product .product-form .title-row .jdgm-widget.jdgm-preview-badge.jdgm-preview-badge--with-link.jdgm--done-setup").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'product_comment',
      "section_id": '' + productId,
      "section_name": "商品介绍",
    });
  })
  $(".section-main-product .product-form").on("click", '.price-container', function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'product_freight',
      "section_id": '' + productId,
      "section_name": "商品介绍",
    });
  })
  //广告位
  Array.from($(".section-main-product .product-form ").children().filter('.lightly-spaced-row.inline-width-container')).forEach((element, index) => {
    $(element).data('index', index)
  });
  // $(".section-main-product .product-form ").children().filter('.lightly-spaced-row.inline-width-container').on("click", function (event) {
  $(".section-main-product .product-form .lightly-spaced-row.inline-width-container").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    console.log($(this).data('index'), this);
    switch ($(this).data('index')) {
      case 0:
        gtag('event', 'click', {
          "content_type": 'advertisement',
          "section_id": '' + productId,
          "section_name": "广告位",
        });
        break;
      case 1:
        gtag('event', 'click', {
          "content_type": 'Product_Line',
          "section_id": '' + productId,
          "section_name": "广告位",
        });
        break;
    }
  })
  //商品数量
  $(".section-main-product .product-form .quantity-wrapper *").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    switch ($(this).index()) {
      case 0:
        gtag('event', 'click', {
          "content_type": 'down',
          "section_id": '' + productId,
          "section_name": "商品数量",
        });
        break;
      case 1:
        gtag('event', 'click', {
          "content_type": 'quantity',
          "section_id": '' + productId,
          "section_name": "商品数量",
        });
        break;
      case 2:
        gtag('event', 'click', {
          "content_type": 'up',
          "section_id": '' + productId,
          "section_name": "商品数量",
        });
        break;
    }
  })
  //添加购物车按钮
  $(".section-main-product .product-form .add-buy-rows").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'add_cart',
      "section_id": '' + productId,
      "section_name": "添加购物车按钮",
    });
  })
  //立刻购买按钮
  $(".section-main-product .product-form #proceed-to-checkout").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'proceed_to_checkout',
      "section_id": '' + productId,
      "section_name": "立即购买按钮",
    });
  })
  //复制优惠码
  $(".section-main-product .product-form .product-coupon-box").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'product_copy_code',
      "section_id": '' + productId,
      "section_name": "复制优惠码",
    });
  })

  //服务类目
  Array.from($(".section-main-product .product-form ").children().filter('.product-detail-accordion.not-in-quickbuy')).forEach((element, index) => {
    $(element).data('index', index)
  });
  $(".section-main-product .product-form ").children().filter('.product-detail-accordion.not-in-quickbuy').on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    switch ($(this).data('index')) {
      case 0:
        gtag('event', 'click', {
          "content_type": 'product_about_size',
          "section_id": '' + productId,
          "section_name": "服务类目",
        });
        break;
      case 1:
        gtag('event', 'click', {
          "content_type": 'product_about_refund',
          "section_id": '' + productId,
          "section_name": "服务类目",
        });
        break;
      case 2:
        gtag('event', 'click', {
          "content_type": 'product_about_coupons',
          "section_id": '' + productId,
          "section_name": "服务类目",
        });
        break;
      case 3:
        gtag('event', 'click', {
          "content_type": 'product_about_deliver',
          "section_id": '' + productId,
          "section_name": "服务类目",
        });
        break;
    }
  })
  //分享
  $(".section-main-product .product-form .sharing-list li").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    switch ($(this).index()) {
      case 0:
        gtag('event', 'click', {
          "content_type": 'facebook_share',
          "section_id": '' + productId,
          "section_name": "分享",
        });
        break;
      case 1:
        gtag('event', 'click', {
          "content_type": 'twitter_share',
          "section_id": '' + productId,
          "section_name": "分享",
        });
        break;
      case 2:
        gtag('event', 'click', {
          "content_type": 'pinterest_share',
          "section_id": '' + productId,
          "section_name": "分享",
        });
        break;
    }
  })
  //评论区域
  $(".section-main-product #judgeme_product_reviews .jdgm-histogram__row").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    console.log($(this).index());
    switch ($(this).index()) {
      case 0:
        gtag('event', 'click', {
          "content_type": 'start_five',
          "section_id": '' + productId,
          "section_name": "评论区域",
        });
        break;
      case 1:
        gtag('event', 'click', {
          "content_type": 'start_four',
          "section_id": '' + productId,
          "section_name": "评论区域",
        });
        break;
      case 2:
        gtag('event', 'click', {
          "content_type": 'start_three',
          "section_id": '' + productId,
          "section_name": "评论区域",
        });
        break;
      case 3:
        gtag('event', 'click', {
          "content_type": 'start_two',
          "section_id": '' + productId,
          "section_name": "评论区域",
        });
        break;
      case 4:
        gtag('event', 'click', {
          "content_type": 'start_one',
          "section_id": '' + productId,
          "section_name": "评论区域",
        });
        break;
      case 5:
        gtag('event', 'click', {
          "content_type": 'all_comment',
          "section_id": '' + productId,
          "section_name": "评论区域",
        });
        break;
    }
  })
  //我要写评论先点击
  $(".section-main-product #judgeme_product_reviews a.jdgm-write-rev-link").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    console.log($(this));
    gtag('event', 'click', {
      "content_type": 'write_comments',
      "section_id": '' + productId,
      "section_name": "评论区域",
    });
  })
  //顾客写真点击
  $(".section-main-product #judgeme_product_reviews ").on("click", '.jdgm-gallery__thumbnail-link', function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    console.log($(this));
    gtag('event', 'click', {
      "content_type": 'customer_photos',
      "section_id": '' + productId,
      "section_name": "评论区域",
    });
  })
  //最新筛选框点击
  $(".section-main-product #judgeme_product_reviews  ").on("click", '.jdgm-sort-dropdown-wrapper', function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    console.log($(this));
    gtag('event', 'click', {
      "content_type": 'filter_box',
      "section_id": '' + productId,
      "section_name": "评论区域",
    });
  })
  //评论翻页查看
  $("#judgeme_product_reviews .jdgm-rev-widg__body").on("click", '.jdgm-paginate', function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'paginate',
      "section_id": '' + productId,
      "section_name": "评论区域",
    });
  })
  //推荐商品区域
  $(".section-product-recommendations").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    console.log($(this));
    if ($(this)[0].baseURI.indexOf('products') > -1) {
      gtag('event', 'click', {
        "content_type": 'section_' + $(this).index(),
        "section_id": '' + $(this).attr('id'),
        "section_name": "商品详细信息下方推荐商品-推荐商品",
      });
    }
  })
  $(".section-featured-collection").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    if ($(this)[0].baseURI.indexOf('products') > -1) {
      gtag('event', 'click', {
        "content_type": 'section_' + $(this).index(),
        "section_id": '' + $(this).attr('id'),
        "section_name": "商品详细信息下方推荐商品-" + $(this).find('.has-paging__title span')[0].innerHTML,
      });
    }
  })

  $("#cart-summary-overlay").on("click", '.to-cart', function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'to_cart',
      "section_id": 'product_id' + productId,
      "section_name": "加购弹窗",
    });
  })

  $(document).on("click", '.altcolour', function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'close_dialog',
      "section_id": 'product_id' + productId,
      "section_name": "加购弹窗",
    });
  })
  //购物页
  $(".cart-coupon").on("click", function (event) {
    const productId = $('.section-main-product .product-form').data('product-id');
    gtag('event', 'click', {
      "content_type": 'card_copy_code',
      "section_id": '' + $(this).attr('id'),
      "section_name": "购物车页面-复制优惠码",
    });
  })

  //购物车商品数量
  $("#cartform .quantity.buttoned-input #updates_dec_1").on("click", function (event) {
    const productId = $('.cart-item').attr('class');
    gtag('event', 'click', {
      "content_type": 'down',
      "section_id": '' + productId,
      "section_name": "购物车商品数量",
    });
  })
  $("#cartform .quantity.buttoned-input #updates_1").on("click", function (event) {
    const productId = $('.cart-item').attr('class');
    gtag('event', 'click', {
      "content_type": 'quantity',
      "section_id": '' + productId,
      "section_name": "购物车商品数量",
    });
  })
  $("#cartform .quantity.buttoned-input #updates_inc_1").on("click", function (event) {
    const productId = $('.cart-item').attr('class');
    gtag('event', 'click', {
      "content_type": 'up',
      "section_id": '' + productId,
      "section_name": "购物车商品数量",
    });
  })
  //  $("#cartform .quantity.buttoned-input *").on("click", function (event) {
  //     const productId = $('.cart-item').attr('class');
  //     switch ($(this).index()) {
  //       case 0:
  //         gtag('event', 'click', {
  //           "content_type": 'down',
  //           "section_id": '' + productId,
  //           "section_name": "购物车商品数量",
  //         });
  //         break;
  //       case 1:
  //         gtag('event', 'click', {
  //           "content_type": 'quantity',
  //           "section_id": '' + productId,
  //           "section_name": "购物车商品数量",
  //         });
  //         break;
  //       case 2:
  //         gtag('event', 'click', {
  //           "content_type": 'up',
  //           "section_id": '' + productId,
  //           "section_name": "购物车商品数量",
  //         });
  //         break;
  //     }
  //   })
  $("#cartform .cart-item__column.cart-item__quantity .remove").on("click", function (event) {
    const productId = $(this).parents('.cart-item').attr('class');
    gtag('event', 'click', {
      "content_type": 'remove',
      "section_id": '' + productId,
      "section_name": "购物车删除按钮",
    });
  })

  $(".textareawrapper").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'cart_note',
      "section_id": '注意事项输入框',
      "section_name": "注意事项输入框",
    });
  })
  $("#cartform #update-cart").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'go_pay',
      "section_id": '前往购买流程按钮',
      "section_name": "前往购买流程按钮",
    });
  })
  $("#cartform #dynamic-checkout-cart").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'go_pay',
      "section_id": '前往购买流程按钮',
      "section_name": "前往购买流程按钮",
    });
  })
  $(".float-checkout.mobile-only .checkout-button").on("click", function (event) {
    gtag('event', 'click', {
      "content_type": 'bottom_go_pay',
      "section_id": '去结账按钮',
      "section_name": "底部悬浮",
    });
  })
  //INS展示区域
  // 当页面加载完成后，将事件处理程序绑定到容器上
  $("#content").on('click', ".social-widget-wrapper a", function (event) {
    gtag('event', 'click', {
      "content_type": 'Ins_Veimia_Japan',
      "section_id": 'shopify-section-template--16207127019660__social_widget_38039',
      "section_name": "INS展示区域",
    });
  })
  $('#shopify-section-template--16207127019660__social_widget_38039').hide()
  setTimeout(() => {
    console.log($("#content .sw-instagram-body"));
    $('#shopify-section-template--16207127019660__social_widget_38039').show()
    $("#content .sw-instagram-body").on('click', function (event) {
      gtag('event', 'click', {
        "content_type": 'Ins_Picture',
        "section_id": 'shopify-section-template--16207127019660__social_widget_38039',
        "section_name": "INS展示区域",
      });
    })
  }, 1000);

  $("#content").on('click', ".sw-instagram-footer", function (event) {
    gtag('event', 'click', {
      "content_type": 'Ins_Picture_More',
      "section_id": 'shopify-section-template--16207127019660__social_widget_38039',
      "section_name": "INS展示区域",
    });
  })
  //活动页埋点-gwsalebra
  $("#shopify-section-template--16914753912972__mian_badge_fjtcCd").on('click', ".badge-item", function (event) {
    const index = $(this).index()+1
    gtag('event', 'click', {
          "content_type": 'gwsalebra_'+index,
          "section_id": 'shopify-section-template--16914753912972__mian_badge_fjtcCd' ,
          "section_name": "gwsalebra_tabs",
        });
  })
  $("#shopify-section-template--16914753912972__special_coupon_b3dVaa").on('click', function (event) {
    gtag('event', 'click', {
          "content_type": 'gwsalebra_4',
          "section_id": 'shopify-section-template--16914753912972__special_coupon_b3dVaa' ,
          "section_name": "gwsalebra_coupon",
        });
  })
  $("#shopify-section-template--16914753912972__sleep_collection_qynKaw").on('click', ".collection-item", function (event) {
    const index = $(this).index()+5
    gtag('event', 'click', {
          "content_type": 'gwsalebra_'+index,
          "section_id": 'shopify-section-template--16914753912972__sleep_collection_qynKaw' ,
          "section_name": "gwsalebra_collection",
        });
  })
  //地区弹窗按钮绑定
  $("body").on('click', "a.button-link", function (event) {
    const html = $(this).html()
    if(html.indexOf('Switch to English⮕')>-1){
      gtag('event', 'click', {
          "content_type": 'English_click',
          "section_id": 'mambasms-forms-container' ,
          "section_name": "区域弹窗",
        });
    }else{
      gtag('event', 'click', {
        "content_type": 'kr_click',
          "section_id": 'mambasms-forms-container' ,
          "section_name": "区域弹窗",
        });
    }
  })
});



